import React from 'react';

export const normal_message_style = {
  fontSize: 15,
  fontWeight: 'bold',
  color: '#0388d0',
}
export const err_message_style = {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#EA2027',
}
export const warn_message_style = {
  fontSize: 15,
  fontWeight: 'bold',
  color: '#ff6348',
}

export const message_style_second = {
  fontSize: 12,
  color: 'grey',
}

/**
 * Center title message box
 */
export const center_title_message_box_wrap_style = {
  display: 'table-cell',
  verticalAlign: 'middle',
}
export const center_title_message_box_style = {
  display: 'inline-block',
  borderRadius: 18,
  fontSize: 24,
  color: 'white',
  padding: '6px 18px',
  backgroundColor: '#0388d0',
  minWidth: 245,
  minHeight: 48,
}

/**
 * Style modules
 */
export const no_outline = {
  outline: 'none',
}

export const DragHandle = (disable) => {
  return (
    <div style={{
      width:'6px', 
      height:'100%',
      // border: '3px solid #1085c5',
      backgroundColor:'#1085c5', 
      borderRadius: 3.5, 
      opacity: disable !== undefined && disable ? 0.5 : 1, 
      pointerEvents: disable !== undefined && disable ? 'none' : 'inherit',
      borderTop: 'none',
      borderBottom: 'none',
      }}>
    </div>
  ) 
}

export const DragHandle_BotProfile = (disable) =>{ 
  return (
    <div className={`chat-profile ${disable ? 'disable' : ''}`}>
      {/* Chatbot profile image */}
    </div>
  )
}